// Safari Private Browsing (and other locked-down runtimes) removes `indexedDB`
// from the global scope entirely. A bare `indexedDB` reference would throw
// `ReferenceError` before the `!` operator runs, so we use `typeof` to detect
// the absent binding without touching it. `typeof` on an undeclared identifier
// returns `"undefined"` without throwing, which also covers SSR contexts where
// `window` itself isn't defined.
//
// We also accept `window.indexedDB` when the bare global is missing. In real
// browsers the two bindings refer to the same object, but jsdom-based tests
// (and the occasional embedded WebView) may only expose one or the other.
export const indexedDbAvailable = (): boolean => {
  if (typeof indexedDB !== "undefined" && !!indexedDB) return true;
  if (typeof window !== "undefined" && !!window.indexedDB) return true;
  return false;
};
